import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const FooterContent = () => {
    return (
        <Container maxWidth={'xl'}>
            <Grid container spacing={0}
                  alignItems="center" justifyItems={'center'}>
                <Grid item xs={12} md={4}>
                    <Typography fontSize="small">
                        {`Copyright Meta Build Consortium @${new Date().getFullYear()} `}
                        All rights reserved
                    </Typography>
                </Grid>

                <Grid item xs={12} md={2} alignItems="center" justifyContent={'center'} justifyItems={'center'}
                      sx={{py: 1}}>
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <img src="/images/ec_logo.svg" alt="" height={'44px'}/>
                    </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Typography fontSize={'small'}
                                alignContent={'center'}>{'Co-funded by the European Union under Grant Agreement no. 101138373.'}</Typography>
                </Grid>
            </Grid>
        </Container>
    );
}

export default FooterContent;